import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import deleteIcon from "../../images/dustbin.png";
import { deleteUnit } from "./httpCalls";
import { removeUnit } from "./unitSlice";

export default function UnitsList() {
  const dispatch = useDispatch();
  const companyCode = localStorage.getItem("companyCode");
  const units = useSelector((state) => state.units);

  const handleDeleteUnit = async (title) => {
    dispatch(removeUnit(title));
    deleteUnit(companyCode, title, dispatch);
  };

  return (
    <Box>
      <Typography
        variant="h5"
        sx={{
          margin: 2,
          display: "flex",
          justifyContent: "center",
          color: "#4EAF51",
        }}
      >
        {companyCode == "8553" ? "Size List" : "Unit List"}
      </Typography>

      <TableContainer component={Paper}>
        {units.units.length == 0 && (
          <Typography
            sx={{
              margin: 2,
              display: "flex",
              justifyContent: "center",
              color: "#4EAF51",
            }}
          >
            {companyCode == "8553" ? "No Size" : " No Unit"}
          </Typography>
        )}
        {units.units.length != 0 && (
          <Table sx={{ minWidth: 550 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Remove</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {units.units.map((item, index) => (
                <TableRow key={index}>
                  <TableCell width="60px" component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {item}
                  </TableCell>
                  <TableCell
                    align="center"
                    width="50px"
                    component="th"
                    scope="row"
                  >
                    <img
                      style={{ cursor: "pointer" }}
                      height="25px"
                      width="25px"
                      src={deleteIcon}
                      alt="delete"
                      onClick={() => handleDeleteUnit(item)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </Box>
  );
}
